import React, { Component } from 'react';
import { utilHelper } from '../../helpers';

class ContentsHistoryItem extends Component {
    render() {
        const { no, history } = this.props;
        return (
            <>
                <tr className="text-align-center">
                    <td data-label="NO">{no}</td>
                    <td data-label="날짜/시간">{utilHelper.getStringDate(new Date(history.regDate))}<br />{utilHelper.getStringTime(new Date(history.regDate))}</td>
                    <td data-label="수정내용" className="text-align-left">{utilHelper.getCodeName(history.logCode)}</td>
                    <td data-label="작성자">{history.userName}</td>
                </tr>
            </>
        );
    }
}

export default ContentsHistoryItem;